<template>
    <v-dialog v-model="dialog" max-width="500" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ editMode ? $t('common.edit') : $t('common.create') }} {{ $t('common.folder') }}
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row>
                    <v-col cols="12">
                        <kimsa-text-field @change="name = $event" :value="name" :label="$t('common.name')"
                            :placeholder="$t('common.folder_name_placeholder')" force-value outlined dense
                            no-elevation />
                    </v-col>
                    <v-col cols="12" v-if="!noImage">
                        <kimsa-upload-file :label="$t('common.image')" relative-path="images/folders"
                            mime-types="image/*" @change="file = $event; deletedImg = false" :preview-img="previewImg"
                            ref="img" height="150" @delete="deletedImg = true" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-0 pb-0">
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-btn block depressed x-large @click="deleteFolder" class="normal-btn" color="error"
                            v-if="folder" style="border-radius: 0" :loading="loadingDelete">
                            {{ $t('common.delete') }}
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-btn block depressed x-large color="primary" class="normal-btn black--text"
                            :disabled="disabled" style="border-radius: 0 0 8px 8px" @click="save" :loading="loading">
                            {{ editMode ? $t('common.edit') : $t('common.create') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import { db, Timestamp } from "@/utils/Firebase";
import { mapMutations, mapState } from "vuex";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import KimsaUploadFile from "@/components/common/inputs/KimsaUploadFile";

export default {
    name: "AdminFoldersDialog",
    components: { KimsaUploadFile, KimsaTextField },
    props: {
        type: {
            type: String,
            default: null,
        },
        coachId: {
            type: String,
            default: null,
        },
        folder: {
            type: Object,
            default: null,
        },
        noImage: {
            type: Boolean,
            default: false,
        },
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            name: '',
            file: null,
            loadingDelete: false,
            deletedImg: false,
        }
    },
    computed: {
        ...mapState(['dialogActive', 'secondDialogActive']),
        disabled(vm = this) {
            return !vm.name || vm.name.length < 3 || vm.loadingDelete
        },
        previewImg(vm = this) {
            if (vm.folder?.img && !vm.deletedImg) return vm.folder?.img || null
            return vm.file?.img || null
        },
        editMode(vm = this) {
            return !!vm.folder
        },
    },
    methods: {
        ...mapMutations(['setDialogActive', 'setSecondDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.isSecondDialog ? vm.setSecondDialogActive(true) : vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.isSecondDialog ? vm.setSecondDialogActive(false) : vm.setDialogActive(false)
            vm.reset()
            vm.$emit('hide')
        },
        reset() {
            const vm = this
            vm.name = ''
            vm.file = null
            vm.deletedImg = false
        },
        async deleteFolder() {
            const vm = this
            vm.loadingDelete = true
            await db.collection('folders').doc(vm.folder.id).delete()

            let refs = await db.collection(vm.type).where('folder', '==', vm.folder.id).get()
            if (refs.docs.length > 0) {
                for (let ref of refs.docs) {
                    await db.collection(vm.type).doc(ref.id).update({ folder: null })
                }
            }

            vm.hide()
            vm.loadingDelete = false
            vm.toast(vm.$t('common.folder_deleted'))
        },
        async save() {
            const vm = this
            vm.loading = true

            let payload = { name: vm.name }
            let img = null
            if (vm.file) {
                img = await vm.$refs.img.upload()
                payload.img = img?.tempUrl || ''
                payload.imgSavePath = img?.savePath || ''
            }

            if (vm.editMode) {
                if (vm.folder.img && !img) {
                    payload.img = null
                    payload.imgSavePath = null
                }
                await db.collection('folders').doc(vm.folder.id).update(payload)
            } else {
                payload.type = vm.type
                payload.coachId = vm.coachId
                payload.createdAt = Timestamp.now()
                await db.collection('folders').add(payload)
            }

            vm.hide()
            vm.loading = false
            vm.editMode ?
                vm.toast(vm.$t('common.folder_updated')) :
                vm.toast(vm.$t('common.folder_created'))
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
        folder(val) {
            if (val?.name) this.name = val.name
        }
    }
}
</script>

<style scoped>
.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}
</style>